module.exports = __webpack_public_path__ + "img/occidental-beach.66b990ff.jpg";